import { FunctionComponent } from 'react';

export interface ILinkTheme {
	ArrowLinkIcon?: FunctionComponent;
	hover: {
		iconSeparator?: string;
	};
	color: string;
}

export const theme: ILinkTheme = {
	ArrowLinkIcon: undefined,
	hover: {
		iconSeparator: '',
	},
	color: '',
};
